import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { DATE_FORMAT } from '../../../constants/constants';
import { TruncateText } from '../../../helpers/strings';
import Button from '../../Common/Button';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import Moment from 'moment';
import Icon from '../../Common/Icon';
import './MissedMilestones.scss';

class UpcomingTasks extends React.Component {
	constructor(props, context) {
		super(props, context);

		this._isMounted = false;

		this.state = {
			isLoading: true,
			showMore: false,
			searchParams: {
				pageSize: 15,
				pageNumber: 1,
				sortDir: 'asc',
				sortBy: 'targetDate',
			},
			tasks: [],
		};
	}

	componentDidMount = async () => {
		this._isMounted = true;
		await this.loadTasks();
	};

	componentWillUnmount = () => {
		this._isMounted = false;
	};

	componentDidUpdate = async (prevProps) => {
		if (this.props.settings && this.props.settings !== prevProps.settings) {
			await this.loadTasks(false);
		}
	};

	loadTasks = async (combineResults) => {
		if (this.props.settings) {
			if (this._isMounted) this.setState({ isLoading: true });
			try {
				let params = this.state.searchParams;
				params.settings = this.props.settings;

				const response = await this.props.companyDashboardActions.loadUpcomingTasks(params);
				if (this._isMounted && response.type === types.LOAD_UPCOMING_TASKS_SUCCESS) {
					if (response.payload.results) {
						const showMore = response.payload.results.length < this.state.searchParams.pageSize ? false : true;
						const combinedTasks = combineResults ? this.state.tasks.concat(response.payload.results) : response.payload.results;
						this.setState({ tasks: combinedTasks.slice(), showMore: showMore });
					} else {
						this.setState({ tasks: [] });
					}
				} else if (this._isMounted && response.type === types.LOAD_UPCOMING_TASKS_FAILURE) {
					Notification('error', 'Error', response.payload.message);
				}
			} catch (error) {
				if (this._isMounted) Notification('error', 'Error', error);
			} finally {
				if (this._isMounted) this.setState({ isLoading: false });
			}
		}
	};

	onShowMore = () => {
		const newPageNumber = this.state.searchParams.pageNumber + 1;
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: newPageNumber } }, () => this.loadTasks(true));
	};

	renderDaysDiff = (task) => {
		const now = new Moment();
		let dayDiffDisplay = '';
		let daysDiff = Moment.utc(task.targetDate).diff(now, 'days');

		if (daysDiff == -1) {
			dayDiffDisplay = '1 day ago';
		} else if (daysDiff < -1) {
			const days = daysDiff == 1 ? 'day' : 'days';
			return (dayDiffDisplay = Math.abs(daysDiff) + ' ' + days + ' ' + 'ago');
		} else if (daysDiff == 0 && daysDiff < 1) {
			dayDiffDisplay = '1 day away';
		} else {
			const days = daysDiff == 1 ? 'day' : 'days';
			dayDiffDisplay = daysDiff + ' ' + days;
		}
		return dayDiffDisplay;
	};

	render() {
		return (
			<Fragment>
				<hr />
				<LoadingIndicator isLoading={this.state.isLoading}>
					{this.state.tasks.map((task) => {
						const taskDisplayState = this.renderDaysDiff(task);
						const isPendingTask = taskDisplayState.includes('ago');
						return (
							<div key={task.id} className='missed-milestones'>
								<div className='pb-2 d-flex align-items-center justify-content-between'>
									<div className='d-flex align-items-center'>
										<Icon name='calendar-alt' className='me-2' />
										{isPendingTask ? (
											<span className='text-danger me-2'>{Moment.utc(task.targetDate).format(DATE_FORMAT)}</span>
										) : (
											<span className='days-ago me-2'>{Moment.utc(task.targetDate).format(DATE_FORMAT)}</span>
										)}
										<span className='days-ago'>({this.renderDaysDiff(task)})</span>
									</div>
									<span className='text-end'>{task.locationName}</span>
								</div>
								<div className='pb-2'>
									<span
										className='description text-primary'
										onClick={() => this.props.onSelectTask(task.id, task.locationKey)}
										style={{ cursor: 'pointer' }}>
										{task.taskName}
									</span>
								</div>
								<div className='pb-2 d-flex align-items-center justify-content-between'>
									<div>
										{task.projectName && <span>{TruncateText(task.projectName, 45)} - </span>}
										{task.statusName}
									</div>
									{task.commentsAdded && (
										<span className='text-end' title='Comments Added'>
											<Icon name='comment' />
										</span>
									)}
								</div>
								<hr />
							</div>
						);
					})}
					{this.state.showMore && (
						<Button type='button' text='Show More' bootstrapClass='light float-end' name='showMore' onClick={this.onShowMore} />
					)}
				</LoadingIndicator>
			</Fragment>
		);
	}
}

UpcomingTasks.propTypes = {
	companyDashboardActions: PropTypes.object.isRequired,
	onSelectTask: PropTypes.func.isRequired,
	settings: PropTypes.object.isRequired,
};

export default UpcomingTasks;
